var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel',{attrs:{"cycle":"","interval":"5000","height":"400"}},_vm._l((_vm.slides),function(slide,index){return _c('v-carousel-item',{key:index,attrs:{"src":slide.img,"alt":slide.title}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }